export function getBundleHashName() {
    return process.env.bundleHashName;
}

export function getBundleDate() {
    return process.env.bundleDate;
}

export function getDisabledIntercom() {
    return process.env.DISABLE_INTERCOM;
}

export function isProductionEnv() {
    return process.env.NODE_ENV === 'production';
}

export function isDevelopmentEnv() {
    return process.env.NODE_ENV === 'development';
}

export function isTestEnv() {
    return process.env.NODE_ENV === 'test';
}

export function isStorybookEnv() {
    return !!window.STORYBOOK_ENV;
}

export function isSandboxEnv() {
    return window.ENVIRONMENT === 'sandbox';
}
